"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Bookmark = function Bookmark() {
    return _react2.default.createElement(
        "g",
        { id: "bookmark" },
        _react2.default.createElement("path", {
            d: "M384.61729,0.0561426684 C389.680522,0.0561426684 394.523614,1.04689564 399.146564,3.02840159 C406.411201,5.89057684 412.18989,10.404007 416.48263,16.5686922 C420.77537,22.7333774 422.92174,29.5585645 422.92174,37.0442536 L422.92174,462.737781 C422.92174,470.22347 420.77537,477.048657 416.48263,483.213342 C412.18989,489.378027 406.411201,493.891458 399.146564,496.753633 C394.963895,498.514971 390.120803,499.395641 384.61729,499.395641 C374.050546,499.395641 364.914714,495.872963 357.209796,488.827609 L211.586845,348.801189 L65.9638946,488.827609 C58.0388361,496.093131 48.9030047,499.725892 38.5564005,499.725892 C33.4931686,499.725892 28.6500773,498.735139 24.0271265,496.753633 C16.7624895,493.891458 10.9838009,489.378027 6.69106089,483.213342 C2.39832084,477.048657 0.25195082,470.22347 0.25195082,462.737781 L0.25195082,37.0442536 C0.25195082,29.5585645 2.39832084,22.7333774 6.69106089,16.5686922 C10.9838009,10.404007 16.7624895,5.89057684 24.0271265,3.02840159 C28.6500773,1.04689564 33.4931686,0.0561426684 38.5564005,0.0561426684 L384.61729,0.0561426684 Z M380.654761,42.3282695 L42.5189297,42.3282695 L42.5189297,452.5 L182.198087,318.418098 L211.586845,290.346764 L240.975604,318.418098 L380.654761,452.5 L380.654761,42.3282695 Z",
            id: "Shape"
        })
    );
};

exports.default = Bookmark;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Bookmark.js
// module id = 2927
// module chunks = 4